module.exports = __webpack_public_path__ + "static/media/book-full-bg.3faec644.jpg";